import BoxNotice from '../components/BoxNotice';
import { getNoticias } from '../service/noticias';
import { useState, useEffect } from 'react';
import { FiCameraOff } from "react-icons/fi";

const Notice = () => {
  const [post, setPost] = useState([]);

  // 📏 Estilo adaptativo para pantallas de 767px o menos
  const getResponsiveStyles = () => {
    const width = window.innerWidth;

    if (width <= 767) {
      return {
        backgroundColor: '#f5f5f5',
        width: '91%',
        height: '70%',
        marginTop: '10px',
        marginLeft: '7%',
        fontFamily: 'Fjalla One',
        overflowY: 'auto',
        padding: '10px',
        boxSizing: 'border-box',
        border: '1px solid #ccc',
      };
    }


    if(width <= 1080){
      return {
        backgroundColor: '#f5f5f5',
        width: '91%',
        height: '80%',
        marginTop: '10px',
        marginLeft: '6.5%',
        fontFamily: 'Fjalla One',
        overflowY: 'auto',
        padding: '10px',
        boxSizing: 'border-box',
        border: '1px solid #ccc',
      }
    }

    // Estilo por defecto para pantallas grandes
    return {
      backgroundColor: '#f5f5f5',
      width: '80%',
      height: '80%',
      marginTop: '1%',
      marginLeft: '15%',
      fontFamily: 'Fjalla One',
      overflowY: 'auto',
      padding: '10px',
      boxSizing: 'border-box',
      border: '1px solid #ccc',
    };
  };

  useEffect(() => {
    const fetchNoticias = async () => {
      const data = await getNoticias();
      setPost(data); // Guarda los datos en el estado
    };

    fetchNoticias(); // Llama a la función para obtener las noticias
  }, []);

  return (
    <div
      className='container-notice'
      style={getResponsiveStyles()}
    >
      <h3 className='title' style={{ textAlign: 'center' }}>NOTICIAS</h3>
      <br />
      <br />
      {/* Renderizar dinámicamente los BoxNotice según el contenido de `post` */}
      {post.length > 0 ? (
        post.map((noticia, index) => (
          <div key={index}>
            <BoxNotice noticia={noticia} />
            <br />
          </div>
        ))
      ) : (
        <div className="notice"
          style={{
            width: '90%',
            margin: '0 auto',
          }}
        >
          <div className="content"
            style={{
              position: 'relative',
              width: window.innerWidth <= 767 ? '95%' : '85%',  // Ajustar el tamaño en pantallas pequeñas
              margin: '0 auto',
              backgroundColor: 'white',
              padding: '15px',
              borderRadius: '5px',
              marginBottom: '10px',
              border: '1px solid rgb(211, 211, 211)',
              boxShadow: '0 0 0 1px hsl(240deg 30% 28% / 5%), 0 2px 5px 0 hsl(240deg 30% 28% / 10%), 0 1px 1px 0 hsl(0deg 0% 0% / 7%)',
              overflow: 'visible',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '200px',
            }}
          >
            <FiCameraOff size={window.innerWidth <= 767 ? 70 : 100} />
            <h1>No hay noticias</h1>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notice;
